/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.rpc.ViewsCrudRpc
 */

export let ComHubspotCrmSearchCore;
(function (_ComHubspotCrmSearchCore) {})(ComHubspotCrmSearchCore || (ComHubspotCrmSearchCore = {}));
export const BoardSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.BoardSettings';
export const BoardSettingsDiscriminant = 'Board Settings';
export const BoardSettingsDiscriminantKey = '@type';
export const CalendarSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.CalendarSettings';
export const CalendarSettingsDiscriminant = 'Calendar Settings';
export const CalendarSettingsDiscriminantKey = '@type';
export const GanttChartSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.GanttChartSettings';
export const GanttChartSettingsDiscriminant = 'Gantt Chart Settings';
export const GanttChartSettingsDiscriminantKey = '@type';
export const MapSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.MapSettings';
export const MapSettingsDiscriminant = 'Map Settings';
export const MapSettingsDiscriminantKey = '@type';
export const ReportSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.ReportSettings';
export const ReportSettingsDiscriminant = 'Report Settings';
export const ReportSettingsDiscriminantKey = '@type';
export const SettingsDiscriminantKey = '@type';
export const TableSettingsTypename = 'com.hubspot.crm.visualization.settings.models.settings.TableSettings';
export const TableSettingsDiscriminant = 'Table Settings';
export const TableSettingsDiscriminantKey = '@type';
export const ConditionalHighlightRuleDiscriminantKey = '@type';
export const GradientRuleTypename = 'com.hubspot.crm.visualization.settings.models.settings.table.models.highlight.rules.GradientRule';
export const GradientRuleDiscriminant = 'Gradient Rule';
export const GradientRuleDiscriminantKey = '@type';

/**
 *  Portal-level view settings upsert request.
 *  Contains all the fields needed for upserting visualization settings at the portal level.
 */

export let ComHubspotSalesModelsViews;
(function (_ComHubspotSalesModelsViews) {})(ComHubspotSalesModelsViews || (ComHubspotSalesModelsViews = {}));
export const getViewRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'getView',
  auth: 'app',
  fingerprint: '2TJPwzaFufvmub1QpAQKoBdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getViewsByComposableSearchRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'getViewsByComposableSearch',
  auth: 'app',
  fingerprint: 'IJc5GJGMLREGpTRCx408jxdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createViewRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'createView',
  auth: 'app',
  fingerprint: 'qHpuVDRGSX7mub1QpAQKoBdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createViewWithVisualizationSettingsAndPermissionsRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'createViewWithVisualizationSettingsAndPermissions',
  auth: 'app',
  fingerprint: 'KRLfNKw_0W836TN5WUDQzRdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateViewRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'updateView',
  auth: 'app',
  fingerprint: 'pqrCmVOjoofmub1QpAQKoBdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateContractSettingsRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'updateContractSettings',
  auth: 'app',
  fingerprint: 'dj-BCEyMeP3mub1QpAQKoBdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkDeleteViewsRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'bulkDeleteViews',
  auth: 'app',
  fingerprint: 'A3kSzmlF8LKcLUGlmLPetRdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkTransferViewOwnershipRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'bulkTransferViewOwnership',
  auth: 'app',
  fingerprint: 'VM85m4lPQRvIRRBdmZ81Dxdr08lDUllB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};